import React from 'react';
import IconAngelAppSVG from '../svg/icon-angel-app';
import classNames from 'classnames';
import {useTranslation} from "react-i18next";
import Link from "../common/Link";
import styles from "./Banner.module.scss";
import detectMobile from '../../helpers/detectMobileSystem'
import {baseURL} from "../../constants";

const SmartBanner = ({show, handleClose}) => {

    let href = `https://radicalstorage.page.link/?link=https%3A%2F%2F${
        typeof baseURL !== 'undefined' ? baseURL : 'radicalstorage.com'
    }/angel%2F&apn=com.angel_app_by_bagbnb&isi=1475876043&ibi=com.leanteamsrl.angel&ius=angel&utm_source=angel-app&utm_medium=smartbanner`;

    const {t} = useTranslation();

   /* if (detectMobile() === 'android'){
        href = 'https://play.google.com/store/apps/details?id=com.angel_app_by_bagbnb'
    } else if (detectMobile() === 'ios') {
        href = 'https://apps.apple.com/us/app/angel-app-by-radical/id1475876043'
    }*/

    return (
        show && <div className={styles.smartbanner}>
            <div className='d-flex'>
                <div className={classNames(styles.smartbannerIcon, 'mr-3')}>
                    <IconAngelAppSVG/>
                </div>
                <div className={styles.smartbannerText}>
                    <span className={classNames(styles.smartbannerTitle, 'd-block mb-1')}>{t('Angel App by Radical')}</span>
                    {t('Worldwide luggage storage network')}
                    <br/>
                    {t('Free: Get it now!')}
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <Link className={classNames(styles.link, 'd-inline-block mr-5')}
                      onClick={()=>handleClose('smartBanner')}>
                    <span className='text-uppercase'>{t('close')}</span>
                </Link>
                <Link className={classNames(styles.link, 'd-inline-block mr-3')} rel
                      label="angel-app"
                      href={href}
                      onClick={()=>handleClose('smartBanner')}>
                    <span className='text-uppercase'>{t('view')}</span>
                </Link>
            </div>
        </div>
    );
};

export default SmartBanner;